"use client";
/*
 * Documentation:
 * Bold footer — https://app.subframe.com/4127f7e60777/library?component=Bold+footer_2db31fe6-873f-46bd-b719-8775d1e5f654
 * Link Button — https://app.subframe.com/4127f7e60777/library?component=Link+Button_a4ee726a-774c-4091-8c49-55b659356024
 */

import React from "react";
import * as SubframeCore from "@subframe/core";
import { LinkButton } from "./LinkButton";

interface BoldFooterRootProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const BoldFooterRoot = React.forwardRef<HTMLElement, BoldFooterRootProps>(
  function BoldFooterRoot(
    { className, ...otherProps }: BoldFooterRootProps,
    ref
  ) {
    return (
      <div
        className={SubframeCore.twClassNames(
          "flex w-full flex-col items-center justify-center gap-6 border-t border-solid border-neutral-100 px-6 py-24",
          className
        )}
        ref={ref as any}
        {...otherProps}
      >
        <div className="flex w-full max-w-[1280px] flex-col items-center gap-12">
          <div className="flex w-full flex-wrap items-start justify-center gap-6">
            <LinkButton>Contact</LinkButton>
            <LinkButton>Give Feedback</LinkButton>
            <LinkButton>Discord</LinkButton>
          </div>
          <div className="flex w-full max-w-[768px] flex-col items-center gap-4">
            <span className="font-['Montserrat'] text-[14px] font-[500] leading-[20px] text-subtext-color text-center">
              © DeckChess 2025
            </span>
          </div>
        </div>
      </div>
    );
  }
);

export const BoldFooter = BoldFooterRoot;
